
import React from 'react';
import PropTypes from 'prop-types';
import '../App.css';

import { withStyles } from '@material-ui/core/styles';
//import Typography from '@material-ui/core / Typography';

import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  container: {
    textAlign: 'center',
    //borderLeft: '3px solid #165469',
    fontFamily: 'Nunito Sans SemiBold',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '110px',
    maxHeight: '110px',
    /*
    [theme.breakpoints.up('tablet')]: {
      minHeight: '140px',
      maxHeight: '140px',
    }, [theme.breakpoints.up('md')]: {
      minHeight: '125px',
      maxHeight: '125px',
    },
    */
  },
  heading: {
    color: '#105269!important',
    fontSize: '14pt',
    textAlign: 'center',
    width: '100%',
  },
  optionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    borderRadius: '5px',
    //paddingLeft: '5px',
  },
  filterOption: {
    paddingLeft: '20px',
    
    textAlign:'left',
  },
  active: {
    //paddingLeft: '0px',
    fontWeight: '700!important',
    color: 'white',
    borderRadius: '5px',
  },
});

function FilterSelector(props) {
  const { classes } = props;

  let totalProduction
  let totalPerInhabitant
  let totalPerSurface
  let chooseProduction
  switch (props.lang) {
    case "de":
      totalProduction = 'Gesamt'
      totalPerInhabitant = 'Pro Einwohner'
      totalPerSurface = 'Pro km\u00b2'
      chooseProduction = 'Wählen Sie die Produktion'
      break;
    case "en":
      totalProduction = 'Total'
      totalPerInhabitant = 'Per inhabitant'
      totalPerSurface = 'Per km\u00b2'
      chooseProduction = 'Choose production mode'
      break;
    case "fr":
    default:
      //productionBy = 'Production par commune'
      //inLabel = "en "
      totalProduction = 'Totale'
      totalPerInhabitant = 'Par habitant'
      totalPerSurface = 'Par km\u00b2'
      chooseProduction = 'Choisissez la production'
  }

  const boolHigherHeader=(props.windowWidth >= 1280 && 
    (
      (props.lang === "de" && props.windowWidth < 1660) || 
      (props.lang === "en" && props.windowWidth < 1536) ||
      props.windowWidth < 1440 
    )
  )
  return (
    <Grid item container 
      className={classes.container + ' mediumgreen'}
      style={{
        minHeight:(boolHigherHeader?'130px':'110px'),
        maxHeight:(boolHigherHeader?'130px':'110px'),
      }}
    >
      <Grid item className={classes.heading}>
        <div
          className={'  mediumgreen'}>
          {chooseProduction}
        </div>
      </Grid>
      <Grid item className={classes.optionContainer + ' bgmediumgrey'}>
        <div
          className={classes.filterOption + ' ' + (props.currentFilter === 'energy' ? (classes.active + ' bggreenblue') : '')}
          data-filter='energy'
          onClick={props.setFilter}
        >
          {totalProduction}
        </div>
        <div
          className={classes.filterOption + ' ' + (props.currentFilter === 'surface' ? (classes.active + ' bggreenblue') : '')}
          data-filter='surface'
          onClick={props.setFilter}
        >
          {totalPerSurface}
        </div>
        <div
          className={classes.filterOption + ' ' + (props.currentFilter === 'inhabitants' ? (classes.active + ' bggreenblue') : '')}
          data-filter='inhabitants'
          onClick={props.setFilter}
        >
          {totalPerInhabitant}
        </div>
      </Grid>
    </Grid>
  );
}

FilterSelector.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FilterSelector);
